import React from 'react';
import PropTypes from 'prop-types';
import { withFormik, Field } from 'formik';
import * as Yup from 'yup';
import { Card, CardHeader, CardBody, FormGroup, Label, FormFeedback, CardFooter, Button, Row, Col } from 'reactstrap';

import { renderField } from 'core/utils/formik';
import CardTitle from 'components/ui/CardTitle/CardTitle';
import DeviceLookup from 'components/DeviceLookup';

const propTypes = {
  initialValues: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

const renderTitle = (initialValues) =>
  initialValues.id ? 'Edit Duplicate Test' : 'New Duplicate Test';

const handleLookupChange = (field, form, resource) => {
  resource = resource || {};
  form.setFieldValue(field.name, resource.id);
};

const renderDevice1Lookup = ({ field, form }) => {
  const { name } = field;
  const { errors, touched, values: { device1 } } = form;

  return (
    <FormGroup color={(touched[name] && errors[name]) ? 'danger' : ''}>
      <Label for="device_id">Device #1</Label>
      <DeviceLookup
        onChange={device => handleLookupChange(field, form, device)}
        onBlur={() => form.setFieldTouched(field.name, true)}
        deviceId={(device1 || {}).id}
        params={{ non_expired: true }}
      />
      {touched[name] && errors[name] && <FormFeedback>{errors[name]}</FormFeedback>}
    </FormGroup>
  )
};

const renderDevice2Lookup = ({ field, form }) => {
  const { name } = field;
  const { errors, touched, values: { device2 } } = form;

  return (
    <FormGroup color={(touched[name] && errors[name]) ? 'danger' : ''}>
      <Label for="device_id">Device #2</Label>
      <DeviceLookup
        onChange={device => handleLookupChange(field, form, device)}
        onBlur={() => form.setFieldTouched(field.name, true)}
        deviceId={(device2 || {}).id}
        params={{ non_expired: true }}
      />
      {touched[name] && errors[name] && <FormFeedback>{errors[name]}</FormFeedback>}
    </FormGroup>
  );
};

const DuplicateTestForm = ({ handleSubmit, isSubmitting, isValid, initialValues }) => {
  return (
    <form onSubmit={handleSubmit}>
      <Card className="pageCard">
        <CardHeader>
          <CardTitle>{renderTitle(initialValues)}</CardTitle>
        </CardHeader>
        <CardBody className="padded">
          <Row>
            <Col md="9">
              <Field
                name="device1_id"
                component={renderDevice1Lookup}
              />
            </Col>

            <Col md="3">
              <Field
                type="number"
                name="result1"
                label="Result #1"
                step="0.01"
                component={renderField}
              />
            </Col>
          </Row>

          <Row>
            <Col md="9">
              <Field
                name="device2_id"
                component={renderDevice2Lookup}
              />
            </Col>

            <Col md="3">
              <Field
                type="number"
                name="result2"
                label="Result #2"
                step="0.01"
                component={renderField}
              />
            </Col>
          </Row>

          <Field
            type="date"
            dateFormat="m/d/Y"
            name="tested_at"
            label="Date"
            component={renderField}
          />
        </CardBody>
        <CardFooter>
          <Button
            type="submit"
            color="primary"
            disabled={!isValid || isSubmitting}
          >
            Save
          </Button>
        </CardFooter>
      </Card>
    </form>
  );
};

const setValidationSchema = () => {
  const schema = {
    device1_id: Yup.string().required('Required'),
    result1: Yup.number().required('Required'),
    device2_id: Yup.string().required('Required'),
    result2: Yup.number().required('Required'),
    tested_at: Yup.string().required('Required'),
  };

  return Yup.object().shape(schema);
};

DuplicateTestForm.propTypes = propTypes;

export default withFormik({
  mapPropsToValues: ({ initialValues }) => {
    const { device1, device2, id } = initialValues;

    if (!id) { return initialValues; }

    return Object.assign(initialValues, {
      device1_id: device1.id,
      device2_id: device2.id,
    });
  },
  validationSchema: () => setValidationSchema(),
  handleSubmit: (values, formikBag) => {
    const { setSubmitting, props: { onSubmit } } = formikBag;
    onSubmit(values, setSubmitting);
  },
  isInitialValid: ({ initialValues }) => {
    const schema = setValidationSchema();
    const result = schema.isValidSync(initialValues);
    return result;
  },
})(DuplicateTestForm);



// WEBPACK FOOTER //
// ./src/features/qa/DuplicateTestForm.js